"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCombienTempsRealisezInvestissementsCorporation = void 0;
exports.ESubCombienTempsRealisezInvestissementsCorporation = {
    less_5_ans: "less_5_ans",
    between_5_10_ans: "between_5_10_ans",
    between_10_15_ans: "between_10_15_ans",
    greater_15_ans: "greater_15_ans",
};
